/**
 * Created by Jasmine on 2018/1/19.
 */

import { observable } from "mobx";
import { Modal } from 'antd'
import { apis, request } from "../../utils/net";
import moment from 'moment';

const store = observable({
    // 审核状态信息
    statusInfo: {},

    // 未登录页面跳转
    step: 3,

    // 全部银行列表
    allBanks: [],

    // 搜索银行列表
    bankList: [],

    // 模糊匹配银行支行列表
    bankBranchList: [],

    // 当前选中的银行
    currentBank: {
        bank_id: '',
        name: ''
    },

    // 当前选中的银行支行
    currentBranch: {
        code: '',
        branch_name: ''
    },

    // 行业列表
    industryList: [],

    // 照片资料url地址数据
    imageData: {
        idcard_front_image: '',
        idcard_back_image: '',
        bk_licence_image: '',
        business_licence_image: '',
        door_image: '',
        cashier_desk_image: '',
        inside_image: '',
        food_health_image: '',
        bank_card_front_image: ''
    },

    // 收款码
    qrcodeUrl: '',

    setStep(date) {
        this.step = date.step
    },

    /**
     * 申请状态
     */
    getOrdersStatus() {
        return request({
            url: apis.getOrdersStatus
        }).then(res => {
            this.statusInfo = res
            return res
        })
    },

    getinvoiceQRcodeData: [],
    /**
     * 获取二维码图片
     */
    getinvoiceQRcode(data) {
        return request({
            url: apis.getinvoiceQRcode,
            method: 'POST',
            data: data,
        }).then(res => {
            this.getinvoiceQRcodeData = res
        })
    },

    getOrdersReSubmitType: true,
    /**
     * 获取开票重试
     */
    getOrdersReSubmit(data) {
        return request({
            url: apis.postBlueRetryOne,
            method: 'POST',
            data: {
                'order_sn': data
            },
        }).then(res => {
            Modal.success({
                title: '成功',
                content: '已再次提交开票',
            });
            this.getOrdersReSubmitType = res
        })
    },

    // 导入查询数据
    store_id: [],

    pay_type: [{
        text: '全部',
        id: ''
    }, {
        text: '微信',
        id: 1
    }, {
        text: '支付宝',
        id: 2
    }],

    type: [{
        text: '全部',
        id: ''
    }, {
        text: '未开票',
        id: 0
    }, {
        text: '开票中',
        id: 1
    }, {
        text: '已开票',
        id: 2
    }, {
        text: '开票失败',
        id: 3
    }],

    getOrdersStoreList() {
        request({
            url: apis.getOrdersStoreList,
            method: 'GET',
        }).then(res => {
            this.store_id = [{
                name: '全部',
                id: ''
            }, ...res] || []
        });
    },

    // 查询数据
    formData: {
        inner_order_no: '',   //订单号
        start_date: moment().startOf('day').unix(),         //起始时间戳
        end_date: moment().unix(),          //终止时间戳
        store_id: '',     //所属门店
        pay_type: '',  //支付方式
        type: ''    //开票状态
    },

    invoiceList: [],
    // invoiceList: [{ "pay_status": 1, "title": "微信支付", "price": "0.10", "status": 3, "date": "2019-04-02 15:36:17", "order_id": 2066, "store_no": "ABC123456789123456", "store_id": 6232, "store_name": "zhoujian", "order_sn": "gp_20190403184605_742_8311_61332", "fail_msg": "111", "is_retry": false }, { "title": "微信支付", "price": "0.10", "status": 0, "date": "2019-04-02 15:36:17", "order_id": 2065, "store_no": "ABC123456789123456", "store_id": 6232, "store_name": "zhoujian", "order_sn": "gp_20190403184605_742_8311_61332", "fail_msg": "", "is_retry": false }],
    currentPage: 1,
    total: 0,

    // 获取列表
    getCollectionList(page, page_size = 10) {
        return request({
            url: apis.getCollectionList,
            method: 'POST',
            data: {
                ...this.formData,
                page: page || this.currentPage,
                page_size
            }
        }).then(res => {
            this.invoiceList = res.list
            this.currentPage = res.page
            this.total = +res.total_count
        })
    },

    // 获取银行列表
    getBankList() {
        return request({
            url: apis.getBankList
        }).then(res => {
            this.allBanks = res
            this.bankList = res
        })
    },

    // 获取行业列表
    getIndustryList() {
        return request({
            url: apis.completeIndustrys
        }).then(res => {
            this.industryList = res
        })
    },

    // 模糊匹配银行支行
    searchBankBranch(keyword) {
        return request({
            url: apis.searchBankBranch,
            data: {
                keyword
            }
        }).then(res => {
            this.bankBranchList = res
        })
    },

    // 提交资料
    submitInfo(params) {
        return request({
            url: apis.submitCollectionInfo,
            method: 'POST',
            data: params
        })
    },

    // 获取用户提交过的申请数据
    getInfo(params) {
        return request({
            url: apis.getCollectionInfo,
            method: 'POST',
            data: params
        }).then(res => {
            this.currentBranch = {
                code: res.bank_code,
                branch_name: res.bank_extra
            }
            this.imageData = {
                idcard_front_image: res.idcard_front_image,
                idcard_back_image: res.idcard_back_image,
                bk_licence_image: res.bk_licence_image,
                business_licence_image: res.business_licence_image,
                door_image: res.door_image,
                cashier_desk_image: res.cashier_desk_image,
                inside_image: res.inside_image,
                bank_card_front_image: res.bank_card_front_image
            }
            return res
        })
    },

    // 获取收款码
    getQrcode() {
        return request({
            url: apis.getReceiptQrcode,
            method: 'POST'
        }).then(res => {
            this.qrcodeUrl = res.url
        })
    },

    // 导出邮箱操作
    setHandleSendEm(parameter){
        return request({
            url: apis.postOrdersExport,
            method: 'get',
            data:{
                ...this.formData,
                ...parameter
            },
        })
    }

});

export default store;
